import { t } from 'ttag';

import map from '../media/map.png';
import sentinel2cloudless from '../media/sentinel2-cloudless.png';

export const MAP_LAYER_TYPES = {
  mapLibre: 'mapLibre',
  tileLayer: 'tileLayer',
};

export const MAP_LAYERS = [
  {
    name: () => t`Voyager Map`,
    image: map,
    type: MAP_LAYER_TYPES.mapLibre,
    settings: {
      SATFARM_INTERNAL_ID: 'VOYAGER_MAP',
      style: `https://api.maptiler.com/maps/voyager/style.json?key=${process.env.REACT_APP_MAPTILER_TOKEN}`,
    },
  },
  {
    url: 'https://maps{s}.wien.gv.at/basemap/bmaporthofoto30cm/{type}/google3857/{z}/{y}/{x}.{format}',
    image: sentinel2cloudless,
    name: () => t`Cloudless Satellite Map`,
    type: MAP_LAYER_TYPES.tileLayer,
    settings: {
      SATFARM_INTERNAL_ID: 'BASE_MAP',
      attribution: 'Datenquelle: <a href="https://www.basemap.at">basemap.at</a>',
      subdomains: ['', '1', '2', '3', '4'],
      type: 'normal',
      format: 'jpeg',
      maxZoom: 19,
    },
  },
];
